import { render, staticRenderFns } from "./ThankYouPage.vue?vue&type=template&id=3283a461&scoped=true"
import script from "./ThankYouPage.vue?vue&type=script&lang=js"
export * from "./ThankYouPage.vue?vue&type=script&lang=js"
import style0 from "./ThankYouPage.vue?vue&type=style&index=0&id=3283a461&prod&lang=scss&scoped=true"
import style1 from "./ThankYouPage.vue?vue&type=style&index=1&id=3283a461&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3283a461",
  null
  
)

export default component.exports